import { getRuntime } from './runtime';
/**
 * Creating storage object for helmet
 * @returns Object for helmet context
 */
export function getHelmetContext() {
    const runtime = getRuntime();
    return runtime.helmetContext;
}
export function registerWidget(name, widget) {
    const runtime = getRuntime();
    runtime.registerWidget({
        name,
        render: widget,
    });
}
export function registerApp(name, application) {
    const runtime = getRuntime();
    runtime.registerApp({ name, render: application(window.INITIAL_STATE[name]) });
}
